import React, {useState, useEffect} from 'react';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {format, fromUnixTime} from 'date-fns';
import {es} from 'date-fns/locale';
import { ReactComponent as IconoDetalle } from './../imagenes/detalle.svg';
import { ReactComponent as IconoEditar } from './../imagenes/editar.svg';
import { ReactComponent as IconoBorrar } from './../imagenes/borrar.svg';
import { ReactComponent as IconoHora } from './../imagenes/hora.svg';
import { ReactComponent as IconoCliente } from './../imagenes/cliente.svg';
import { ReactComponent as IconoEstado } from './../imagenes/estado.svg';
import useObtenerViajesDescarga from './../hooks/useObtenerViajesDescarga';
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from './../elementos/Header';
import BotonCerrarSesion from "./../elementos/BotonCerrarSesion";
import {
  Lista,
  ElementoLista,
  Descripcion,
  Fecha,
  BotonAccion,
  BotonCargarMas,
  ContenedorBotonCentral,
  ContenedorSubtitulo,
  Subtitulo,
  Boton
} from './../elementos/ElementosApp';
import SelectPasajeros from './../componentes/SelectPasajeros'
import IconoMovilEstado from "./../elementos/IconoEstado";
import BtnRegresar from "../elementos/BtnRegresar";


import DateTimePicker from './DateTimePricker';
import {
	ContenedorSubtituloPequeño,  ContenedorFiltros,Contenedor, Formulario,
	Input, ContenedorBoton,Btn, ContenedorLista,ContenedorItinerario,ContenedorInputConIcono
} from '../elementos/ElementosDeFormulario';
import SelectClientes from './SelectClientes';



const  TrasladosTerminados = () => {

    const viajes= useObtenerViajesDescarga();
    console.log(viajes)
    //const viajesfiltroCancelado = viajes.filter(item => item.estado !== 'Asignado')
    const viajesfiltroTerminado = viajes.filter(item => item.estado !== 'Activo')
    const [fechahoraviaje, cambiarFechahoraviaje] = useState ('Ingrese Fecha y hora de Viaje');
    const [cliente, cambiarCliente] = useState ('Seleccione Cliente');
    const [listado, cambiarListado] = useState([]);

    const [fechaActual, cambiarFechaActual] = useState (new Date());
    const formatearFecha = (fecha) => {
          return format(fromUnixTime(fecha), "yyyy/MM/dd", {locale: es})
      }
    const formatearHora = (fecha) => {
          return format(fromUnixTime(fecha), "HH':'mm'", {locale: es})
      }
  
    function toTimestamp(strDate){
      var datum = Date.parse(strDate);
      return datum;
   }
  
  //console.log(viajesfiltroTerminado);
  const viajesordenadorfecha = viajesfiltroTerminado.sort((a, b) => (a.fecha_hora_programada < b.fecha_hora_programada ? 1 : a.fecha_hora_programada > b.fecha_hora_programada ? -1 : 0))
  //console.log(viajesordenadorfecha);

    
    
    



    return ( 
        <>
        <Helmet>
        <title> Traslados Terminados  </title>
        </Helmet>
            <Header>
                <BtnRegresar></BtnRegresar>
                <Titulo>Traslados Terminados</Titulo>         
            </Header>

  
                        {viajesordenadorfecha.map((viaje) => {
    
                              let pasajeros2 = Object.keys(viaje.pasajeros).map(function (key) {return {id : key, ...viaje.pasajeros[key]};});
                              //console.log(pasajeros2);
                              return(<>
                              
                              {pasajeros2.map((pasajero) => {
                                
                                return(
                                  <> 
                                  {viaje.id};{formatearFecha(viaje.fecha_hora_programada/1000)};{formatearHora(viaje.fecha_hora_programada/1000)};{viaje.estado};{viaje.numero_m};{pasajero.nombre};
                                  {pasajero.telefono};{pasajero.direccion_o};{pasajero.rfc};{viaje.empresa};{pasajero.direccion_d}<br/>
                                 
                                  </>
                                  
                                  );
                                
      
                                
                                    })
                              
                                  }
                              
                              </>)

                              
                              })
                        }
                        
                        
                       



    </>
  );
}
 
export default  TrasladosTerminados;